<template>
	<div :key="courseId" class="row page-heading hideToc" v-if="permission && permission.version === '5'">

		<div class="col-7 input module_heading">
			<span class="module_icon icon-course"></span>
            <template v-if="isCurate">
                <input type="text" v-model="course.title" v-bind:aria-label="course.title" style="width: 92%;"/>
            </template>
            <template v-else>
                <label class="head_txt module_type_name" role="heading" aria-level="1">{{course.title}}</label>
                <template v-if="course.master">
                    <span class="icon-master">m</span>
                </template>
            </template>
		</div>

		<div class="col-5 float-right px-0">
			<div class="submit btn-container">
				<template>
    				<b-button @click="hideToc" variant="primary" style="float:right;" class="hideBtn" aria-label="hide toc" :disabled="disableTOC">{{LABELS.HIDE_TOC}}</b-button>
    				<b-button @click="showToc" variant="primary" style="float:right;" class="btn_hide_toc showBtn" aria-label="show toc" :disabled="disableTOC">{{LABELS.SHOW_TOC}}</b-button>
				</template>
			</div>
		</div>
        <div class="loading-spinner" v-show="loading">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'courseHeaderSR',
  props: ['courseId', 'title', 'plan', 'canEdit', 'isCurate', 'disableTOC'],
  data: () => {
    return {
      submitted: false,
      isStudentLogin: (localStorage.getItem('userrole') === 'Student'),
      sandboxUsers: ['demoinstructor2@nu.com', 'i1@csu.edu', 'i2@csu.edu', 'i1@vc.edu', 'i2@vc.edu', 'randolph.ward@teachforamerica.org', 'cassandra.zimmer@teachforamerica.org', 'caitlin.ormsby@teachforamerica.org', 'bkransberger@nu.edu', 'i1@lsc.edu', 'i1@pima.edu', 'trinaldi@nu.edu', 'jzavala@nu.edu']
    }
  },
  components: {
  },

  watch: {
    courseId (value) {
      this.$store.commit('LOAD_CONTINUE_LEARNING', {})
      if (value) {
        this.loadCourse()
      }
    }
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'saveCourseDetail',
      'autonumberContent'
    ]),

    bblmslink () {
      if (this.course && this.course.lmsCourseId) {
        return 'https://nu.blackboard.com/webapps/blackboard/execute/launcher?type=Course&id=_' + this.course.lmsCourseId + '_1&url='
      }
    },

    loadCourse () {
      this.loadCourseDetail(this.courseId)
    },

    cancel () {
      if (this.course.title.localeCompare(this.title) !== 0) {
        this.$store.commit('LOAD_COURSE', {})
      }
      return this.$router.push({ name: 'courseDashboardInstructor', params: { uuid: this.courseId } })
    },

    autonumber () {
      this.showLoader()
      this.submitted = true
      this.course.plan = this.generatePlan(this.plan)
      this.saveCourseDetail(this.course).then((res) => {
        this.autonumberContent(this.course).then((res) => {
          this.$emit('saved', JSON.parse(res.plan))
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Course "' + res.title + '" saved and tree re-numbered successfully.'
          })
          this.hideLoader()
          this.submitted = false
        })
      })
    },

    save () {
      this.showLoader()
      this.submitted = true
      this.course.plan = this.generatePlan(this.plan)
      this.saveCourseDetail(this.course).then((res) => {
        this.$emit('saved', JSON.parse(res.plan))
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Course "' + res.title + '" updated successfully.'
        })
        this.hideLoader()
        this.submitted = false
      })
    },

    done () {
      this.showLoader()
      this.submitted = true
      this.course.plan = this.generatePlan(this.plan)
      this.saveCourseDetail(this.course).then((res) => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Course "' + res.title + '" updated successfully.'
        })
        this.hideLoader()
        this.returnToDashboard()
      })
    },

    generatePlan (plan) {
      $.each(plan, (i, item) => {
        delete item.id
        if (item.type === 'LearningTopic') {
          if (item.children.length > 0) {
            this.generatePlan(item.children)
          }
        } else {
          delete item.children
          delete item.isDataRendered
          delete item.isStudentEditable
        }
      })
      return JSON.stringify(plan)
    },

    returnToDashboard () {
      let userPermission = this.permission.userPermission
      if (userPermission.studentHomeView) {
        return this.$router.push({ name: 'studentDashboard' })
      } else if (userPermission.instructorHomeView) {
        if (userPermission.adminHomeView) {
          return this.$router.push({ name: 'adminDashboard' })
        } else {
          return this.$router.push({ name: 'instructorDashboard' })
        }
      }
    },

    hideToc () {
      $('.page-content').addClass('hideToc').removeClass('showToc')
      $('.page-heading').addClass('hideToc').removeClass('showToc')
    },

    showToc () {
      $('.page-heading').addClass('showToc').removeClass('hideToc')
      $('.page-content').addClass('showToc').removeClass('hideToc')
      let parentSelector = $('.topic-list-item > .expand-bydefault')
      let iconSelector = $('.row_1 > .icon')
      $(parentSelector).removeAttr('style', 'display: none;')
      $(parentSelector).addClass('show')
      if ($(parentSelector).hasClass('show')) {
        $(iconSelector).removeClass('ic-expand_r').addClass('ic-collapse_r')
      }
      if (!$(parentSelector).hasClass('show')) {
        $(iconSelector).addClass('ic-expand_r').removeClass('ic-collapse_r')
      }
    },

    showLoader () {
      this.loading = true
      this.$refs.loadingModal.show()
    },

    hideLoader () {
      this.loading = false
      this.$refs.loadingModal.hide()
    },

    naviagteToCourseCuration () {
      var path = this.$router.history.current.path
      var url = '/course/' + this.course.uuid + '/learn'
      if (path === url) {
        return this.$router.push({ name: 'courseCuration', params: { uuid: this.course.uuid } })
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'topics': state => state.course.topics,
      'continueLearning': state => state.course.continueLearning,
      'permission': state => state.user.permission
    }),

    isSandboxUser: function () {
      var uObj = JSON.parse(localStorage.getItem('userobj'))
      if (uObj) {
        return this.sandboxUsers.includes(uObj.eMail)
      }
      return false
    },

    isOpenCourse () {
      if (this.course && (this.course.courseType === 'OPEN' || (this.course.courseType && this.course.courseType.includes('EXTERNAL_')))) {
        return true
      } else {
        return false
      }
    }
  }

}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseHeaderSR.vue